import * as actionTypes from "../actions/actionsTypes";

const initialState = {
  sharingRaceDataTo: {
    data: {},
  },
};

export const sharingRaceDataToReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SHARING_SESSIONS_TO:
      return {
        ...state,
        sharingRaceDataTo: action.payload,
      };
    case actionTypes.UPDATE_SHARING_SESSIONS_TO:
      return {
        ...state,
        sharingRaceDataTo: action.payload,
      };
    case actionTypes.EMPTY_SHARING_SESSIONS_TO:
      return {
        ...state,
        sharingRaceDataTo: action.payload,
      };
    default:
      return state;
  }
};
